import TopHeader from "./topheader.js";
import Footer from './footer.js';

export default function Partners() {
    return (
        <>
            <TopHeader MenuLevel="Partners" />
            <Footer />
        </>
    )
}